module.exports = __webpack_public_path__ + "static/media/p2.24064530.mp4";